function Hello(){
    return <h1>Kacper Woszczyło 21324</h1>
}

export default Hello;
